import React, { MouseEvent, useCallback, useEffect, useState } from 'react';

import * as S from './styles';

interface IModalProps {
  onClose(): void;
  withScroll?: boolean;
  canClose?: boolean;
}

const Modal: React.FC<IModalProps> = ({
  onClose,
  withScroll = false,
  canClose = true,
  children,
}) => {
  const [itsClosing, setItsClosing] = useState(false);
  const handleControlPropagation = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    },
    [],
  );

  const handleCloseModal = useCallback(() => {
    setItsClosing(true);
    setTimeout(() => {
      onClose();
    }, 200);
  }, [onClose]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100vh';

    return () => {
      document.body.style.overflow = 'auto';
      document.body.style.height = 'initial';
    };
  }, []);

  return (
    <S.ContainerWrapper onClick={handleCloseModal} role="presentation">
      <S.Container
        onClick={handleControlPropagation}
        className={`modal-container${withScroll ? ' withScroll' : ''}${
          canClose ? ' canClose' : ''
        }${itsClosing ? ' closing' : ''}`}
        withScroll={withScroll}
      >
        {canClose && (
          <img
            src="/images/icons/x.svg"
            alt="Fechar"
            className="icon close-icon"
            onClick={handleCloseModal}
          />
        )}

        <div className={`modal-content${withScroll ? ' withScroll' : ''}`}>
          {children}
        </div>
      </S.Container>
    </S.ContainerWrapper>
  );
};

export default Modal;
